// Название «Спроси Turkido» — как на плавающей кнопке: «Спроси» золотым
// (--tk-brand-gold, прежний --tk-gold; сам акцент с 28.09 красный), «Turkido» тем же
// начертанием, что и логотип-вордмарк в хедере (font-display font-bold, белый).
export function TutorBrandLabel() {
  return (
    <>
      <span style={{ color: 'var(--tk-brand-gold)' }}>Спроси</span>{' '}
      <span className="font-display font-bold" style={{ color: 'var(--foreground)' }}>
        Turkido
      </span>
    </>
  )
}
